import { render, staticRenderFns } from "./EcommerceHubV.vue?vue&type=template&id=8c8b0ec8"
import script from "./EcommerceHubV.vue?vue&type=script&lang=js"
export * from "./EcommerceHubV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports